import styled from "styled-components/native";
import { StyleSheet } from "react-native";

export const Overlay = styled.View<{ isDark: boolean }>`
  ${StyleSheet.absoluteFill};
  ${({ isDark }) => (isDark ? "background-color: rgba(0,0,0,0.5)" : "")}
`;
